import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../../utils/commonColumns";
import { renderNA } from "../../../../../../utils/commonFunctions";

const titleColumn: ColDef = {
  field: "title",
  headerName: "Title",
  cellRenderer: (props: any) => {
    return renderNA(props.data.title);
  },
};

const columnDefs: ColDef[] = [
  idColumn,
  titleColumn,
  statusColumn,
  actionColumn,
];
export default columnDefs;
